/**
 * Event Time Timezone Converter
 *
 * Detects the visitor's local timezone, then converts and re-renders all
 * event time elements that carry data-start / data-end ISO datetime attributes.
 *
 * Targets:
 *   .event-time[data-start]   — used by calendar-list.ejs and event-list.ejs
 *   .js-event-time[data-start] — used by groups.ejs inline time spans
 */

function _getTzAbbr(date, timeZone) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'short'
  }).formatToParts(date);
  const part = parts.find(p => p.type === 'timeZoneName');
  return part ? part.value : '';
}

function _formatTime(date, timeZone) {
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone
  });
}

function _buildTimeString(startDate, endDate, timeZone) {
  const startStr = _formatTime(startDate, timeZone);
  const tzAbbr   = _getTzAbbr(startDate, timeZone);

  if (endDate && !isNaN(endDate) && endDate.getTime() !== startDate.getTime()) {
    const endStr = _formatTime(endDate, timeZone);
    return `${startStr} \u2013 ${endStr} ${tzAbbr}`;
  }
  return `${startStr} ${tzAbbr}`;
}

function initEventTimezones() {
  let timeZone;
  try {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (_) {
    return; // Browser doesn't support Intl — leave server-rendered text as-is
  }

  // .event-time divs — calendar-list.ejs and event-list.ejs
  document.querySelectorAll('.event-time[data-start]').forEach(el => {
    const startDate = new Date(el.dataset.start);
    if (isNaN(startDate)) return;

    const endDate = el.dataset.end ? new Date(el.dataset.end) : null;
    const span = el.querySelector('span');
    if (!span) return;

    span.textContent = _buildTimeString(startDate, endDate, timeZone);
  });

  // .js-event-time spans — groups.ejs
  document.querySelectorAll('.js-event-time[data-start]').forEach(el => {
    const startDate = new Date(el.dataset.start);
    if (isNaN(startDate)) return;

    const endDate = el.dataset.end ? new Date(el.dataset.end) : null;
    el.textContent = _buildTimeString(startDate, endDate, timeZone);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEventTimezones);
} else {
  initEventTimezones();
}
